  import * as ActionTypes from "../Types/ActionTypes";

  export const EmployeeAnalytic = (
    state = {
      isLoading: false,
      employeeAnalyticState: null,
    },
    action
  ) => {
    switch (action.type) {
      case ActionTypes.EMPLOYEE_ANALYTIC_LOADER_START:
        return {
          ...state,
          isLoading: true,
        };

      case ActionTypes.EMPLOYEE_ANALYTIC:
        return {
          ...state,
          isLoading: false,
          employeeAnalyticState: action.payload,
        };

      case ActionTypes.EMPLOYEE_ANALYTIC_LOADER_STOP:
        return {
          ...state,
          isLoading: false,
        };

      default:
        return state;
    }
  };
